import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const VerifyEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const email = location.state?.email || '';

  if (!email) {
    navigate('/login');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/verify-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success(data.message);
        navigate('/login');
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error('Verification failed. Try again.');
    }
  };

  const handleResend = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/resend-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error('Failed to resend OTP.');
    }
  };

  return (
    <div className="p-4 flex justify-center items-center min-h-[70vh]">
      <div className="bg-white shadow-lg p-6 rounded w-full max-w-md text-center">
        <h1 className="text-2xl font-bold mb-4">Verify Your Email</h1>
        <p className="mb-6 text-gray-600">Please enter the OTP sent to {email}</p>
        <form onSubmit={handleSubmit} className="flex flex-col mb-4">
          <input
            type="text"
            className="p-2 border rounded mb-4 text-center text-lg tracking-widest"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />
          <button className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-2 rounded">
            Verify
          </button>
        </form>
        <button onClick={handleResend} className="text-blue-600 hover:underline text-sm">
          Resend OTP
        </button>
      </div>
    </div>
  );
};

export default VerifyEmail;
